import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { biBeforeAndAfter, biChangePage } from '../../../services/biHelpers';
import { ActionTypes, ScreenNames } from '../../main/biInterfaces';
import { request } from '../../../services/request';
import { monitoringPropsMap } from '../../Monitoring/MonitoringPropsMap';
import { FedopsInteraction } from '../../../config/fedopsInteraction';
import { deleteParticipant } from '@wix/ambassador-challenges-v1-participant/http';
import { handleError } from '../../ErrorHandler/errorHandlerPropsMap';

export const leaveProgram = async (
  flowAPI: ControllerFlowAPI,
  participantId: string,
  challengeId: string,
) => {
  await biBeforeAndAfter(
    flowAPI.bi,
    ActionTypes.LEAVE_THE_CHALLENGE,
    async (actionId) => {
      try {
        const res = await request({
          flowAPI,
          options: deleteParticipant({
            actionId,
            challengeId,
            participantId,
          }),
          errorOptions: {
            errorCodesMap: {
              applicationError: {},
            },
          },
        });
        return res?.data;
      } catch (e) {
        const resolvedError = flowAPI.errorHandler.getResolvedError(e);
        handleError({
          error: e,
          resolvedError,
          context: 'leaveProgram',
        });
      }
    },
  );

  await biChangePage(flowAPI.bi, ScreenNames.ChallengePage);
  const { endInteraction } = monitoringPropsMap(flowAPI);
  endInteraction(FedopsInteraction.LeaveFromProgram, challengeId);
};
